import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { UserProvider } from './context/UserContext';
import { NotificationProvider } from './context/NotificationContext';
import AppRoutes from './routes/AppRoutes';
import { LoadingScreen } from './components/common/LoadingScreen';
import { useSupabaseConnection } from './hooks/useSupabaseConnection';
import { SessionRecovery } from './components/SessionRecovery';

function App() {
  const { isChecking } = useSupabaseConnection();
  
  if (isChecking) {
    return <LoadingScreen />;
  }
  return (
    <BrowserRouter>
      <SessionRecovery />
      <AuthProvider>
        <ThemeProvider>
          <UserProvider>
            <AppRoutes />
          </UserProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;